import { LocalDate } from '../../../core/model/local-date';
import { RentInvoicingOrderSettings } from './rent-invoicing-order-settings';

export class RentInvoicingOrderCreateModel {
  appendixes: any[];

  caption: string;
  dueFrom: LocalDate;
  dueTo: LocalDate;

  settings: RentInvoicingOrderSettings;
}
